var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataCache } from '../../DataCache';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { IsAllowed } from '../../IsAllowed';
import { SessionOperations } from '@shared/utils/Enums/Constants';
import { TradingPositionType } from '@shared/utils/Instruments/TradingPositionType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { TvDurationConvertor } from '../Convertors/TvDurationConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { ApplicationInfo } from '../../ApplicationInfo';
class _TvBrokerConfigFlags {
    getConfigFlags(instrument, account) {
        const isAllowTradingForPlaceOrder = this.isTradingAllowed(instrument, account, SessionOperations.Open) || ApplicationInfo.isExploreMode;
        const isAllowTradingForModifyOrder = this.isTradingAllowed(instrument, account, SessionOperations.Modify);
        const iAllowModifyOrder = isAllowTradingForModifyOrder && this.isAllowModifyOrder(account, instrument);
        const configFlags = {
            showQuantityInsteadOfAmount: true,
            supportOrderBrackets: this.isSupportOrderBrackets(instrument, account),
            supportTrailingStop: false, // this.isAllowTrailingStop(account),
            supportPositions: this.isAllowPositionsPanel(account), // TODO: NEW RULE FROM SERVER
            supportPositionBrackets: this.isSupportPositionBrackets(instrument, account),
            supportIndividualPositionBrackets: this.isSupportIndividualPositionBrackets(), // Not used, related to Position netting type = Net position by FIFO
            supportPositionNetting: false, // Not used, related to Position netting type = Net position by FIFO
            supportClosePosition: true,
            supportCloseIndividualPosition: false, // Not used, related to Position netting type = Net position by FIFO
            supportModifyOrderPrice: iAllowModifyOrder,
            supportEditAmount: iAllowModifyOrder,
            supportModifyBrackets: this.isSupportModifyBrackets(instrument, account),
            supportLevel2Data: this.isAllowPanel(RulesSet.FUNCTION_SUPER_DOM), // TODO use from Products field FIELD_IS_MD
            supportDOM: this.isAllowPanel(RulesSet.FUNCTION_SUPER_DOM),
            supportMultiposition: this.isSupportMultiPosition(instrument),
            supportPLUpdate: true,
            supportReversePosition: this.isSupportReversePosition(),
            supportNativeReversePosition: false,
            supportMarketOrders: isAllowTradingForPlaceOrder && this.isAllowOrderType(instrument, OrderType.Market),
            supportLimitOrders: isAllowTradingForPlaceOrder && this.isAllowOrderType(instrument, OrderType.Limit),
            supportStopOrders: isAllowTradingForPlaceOrder && this.isAllowOrderType(instrument, OrderType.Stop),
            supportStopLimitOrders: isAllowTradingForPlaceOrder && this.isAllowOrderType(instrument, OrderType.StopLimit),
            supportDemoLiveSwitcher: false,
            supportMarketBrackets: this.isAllowSltp(instrument, account),
            supportSymbolSearch: true, // ?
            supportModifyDuration: iAllowModifyOrder,
            supportModifyTrailingStop: false, // iAllowModifyOrder && this.isAllowOrderType(instrument, OrderType.TrailingStop),
            supportMargin: true,
            calculatePLUsingLast: this.isCalculatePLUsingLast(instrument),
            supportPlaceOrderPreview: !ApplicationInfo.isExploreMode,
            supportModifyOrderPreview: false,
            supportLeverage: false, // UNKNOWN property
            supportLeverageButton: true, // UNKNOWN property
            supportOrdersHistory: this.isAllowPanel(RulesSet.FUNCTION_ORDER_BOOK),
            supportAddBracketsToExistingOrder: this.isSupportAddBracketsToExistingOrder(instrument, account),
            supportBalances: false, // UNKNOWN property
            closePositionCancelsOrders: true,
            supportOnlyPairPositionBrackets: false,
            supportCryptoExchangeOrderTicket: false, // UNKNOWN property
            positionPLInInstrumentCurrency: false,
            supportPartialClosePosition: this.isAllowPartialCloseForPosition(account),
            supportPartialCloseIndividualPosition: false, // UNKNOWN property
            supportCancellingBothBracketsOnly: false,
            supportCryptoBrackets: false, // UNKNOWN property
            showNotificationsLog: this.isAllowPanel(RulesSet.FUNCTION_EVENT_LOG),
            supportStopOrdersInBothDirections: false,
            supportStopLimitOrdersInBothDirections: false,
            supportExecutions: true,
            supportModifyOrderType: false,
            requiresFIFOCloseIndividualPositions: false // UNKNOWN property
        };
        return configFlags;
    }
    getSymbolSpecificTradingOptions(symbol) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const interiorId = TvInteriorIdCache.getInteriorId(symbol);
                const instrument = DataCache.getInstrumentByName(interiorId);
                if (isNullOrUndefined(instrument)) {
                    resolve(undefined);
                    return;
                }
                const account = TvAccountHelper.getCurrentAccount();
                const allowedDurations = TvDurationConvertor.getAllowedDurationsForInstrumentAccount(instrument, account);
                const symbolSpecificTradingOptions = {
                    allowedDurations: allowedDurations.map((x) => x.value),
                    allowedOrderTypes: TvDurationConvertor.getAllowedTvOrderTypes(instrument, account),
                    supportOrderBrackets: this.isSupportOrderBrackets(instrument, account),
                    supportAddBracketsToExistingOrder: this.isSupportAddBracketsToExistingOrder(instrument, account),
                    supportModifyBrackets: this.isSupportModifyBrackets(instrument, account),
                    supportPositionBrackets: this.isSupportPositionBrackets(instrument, account),
                    supportIndividualPositionBrackets: this.isSupportIndividualPositionBrackets(), // Not used, related to Position netting type = Net position by FIFO
                    supportReversePosition: this.isSupportReversePosition()
                    // warningMessage
                };
                resolve(symbolSpecificTradingOptions);
            });
        });
    }
    isAllowSltp(instrument, account) {
        // if(!account)
        // {
        //     return DataCache.isAllowedForMainAccount(RulesSet.FUNCTION_SLTP);
        // }
        // return DataCache.isAllowedForAccount(RulesSet.FUNCTION_SLTP, account);
        const allowSL = IsAllowed.IsSLTPAllowed(instrument, account, true).Allowed;
        const allowTP = IsAllowed.IsSLTPAllowed(instrument, account, false).Allowed;
        return allowSL && allowTP;
    }
    isAllowTrailingStop(account) {
        return DataCache.isAllowedForAccount(RulesSet.FUNCTION_TRAILING_STOP, account);
    }
    isAllowPositionsPanel(account) {
        return DataCache.isAllowedForMyUser(RulesSet.FUNCTION_SHOW_POSITIONS);
    }
    isAllowModifyOrder(account, instrument) {
        return IsAllowed.Check_Session_Operation(account, instrument, SessionOperations.Modify);
    }
    isAllowPanel(rule) {
        return DataCache.isAllowedForMyUser(rule);
    }
    isSupportMultiPosition(instrument) {
        const posType = instrument === null || instrument === void 0 ? void 0 : instrument.TradingPositionType;
        switch (posType) {
            case TradingPositionType.OnePosition: // Net position by average price
            case TradingPositionType.NotPositionByFIFO:
                return false;
            case TradingPositionType.MultiPosition: // Hedging
            case TradingPositionType.MultiPositionPerSide: // MultiPositionPerSide
            default:
                return true;
        }
    }
    isAllowOrderType(instrument, orderType) {
        return instrument === null || instrument === void 0 ? void 0 : instrument.IsAllowOrderType(orderType);
    }
    isCalculatePLUsingLast(instrument) {
        return instrument === null || instrument === void 0 ? void 0 : instrument.CalcPriceOnTrade();
    }
    isAllowPartialCloseForPosition(account) {
        // TODO: TradingPositionType.OnePosition - разрешено на WinDesktop
        return DataCache.isAllowedForAccount(RulesSet.FUNCTION_PARTIAL_CLOSE, account);
    }
    isTradingAllowed(instrument, account, sessionOperation) {
        return IsAllowed.IsTradingAllowed(account, instrument, -1, sessionOperation).Allowed;
    }
    isSupportOrderBrackets(instrument, account) {
        return this.isAllowSltp(instrument, account);
    }
    isSupportAddBracketsToExistingOrder(instrument, account) {
        return this.isAllowSltp(instrument, account);
    }
    isSupportModifyBrackets(instrument, account) {
        const isAllowTradingForModifyOrder = this.isTradingAllowed(instrument, account, SessionOperations.Modify);
        const iAllowModifyOrder = isAllowTradingForModifyOrder && this.isAllowModifyOrder(account, instrument);
        return this.isAllowSltp(instrument, account) && iAllowModifyOrder;
    }
    isSupportPositionBrackets(instrument, account) {
        return this.isAllowSltp(instrument, account);
    }
    isSupportIndividualPositionBrackets() {
        return false;
    }
    isSupportReversePosition() {
        return false;
    }
}
export const TvBrokerConfigFlags = new _TvBrokerConfigFlags();
